import { render } from "./LanguageSwitcher.vue?vue&type=template&id=76afd82c&scoped=true&ts=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=76afd82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76afd82c"]])

export default __exports__